import { Component, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { EnergySettingsSetpValue, EnergyUtilizationSettings, UtilizationSettingType } from '../site-utilization-settings.interface';
import { Subscription } from 'rxjs';
import { SitesService } from 'src/app/sites/sites.service';
import { ActivatedRoute } from '@angular/router';
import { NotificationMessageService } from 'src/app/shared/notification-message/notification-message.service';

@Component({
	selector: 'app-energy-site-settings',
	templateUrl: './energy-site-settings.component.html',
	styleUrls: ['./energy-site-settings.component.css']
})
export class EnergySiteSettingsComponent  implements OnInit, OnDestroy {
	siteId: number;
	disableButton: boolean = false;
	settingType: UtilizationSettingType = UtilizationSettingType.Energy;
	energyStepValues = EnergySettingsSetpValue;
	subSite: Subscription = new Subscription();

	energySettings: EnergyUtilizationSettings = {
		max_disconnect_days: 5,
		low_disconnect_range_min: 7,
		low_disconnect_range_max: 15,
		mid_disconnect_range_min: 16,
		mid_disconnect_range_max: 31,
		high_disconnect_limit: 32,
		minimum_meter_daily_kwh_usage: 5,
		maximum_meter_daily_kw_demand: 5,
		energy_cost: 8,
		energy_demand_charge: 10,
	};

	constructor(
		private siteService: SitesService,
		private elementRef: ElementRef,
		private render: Renderer2,
		private route: ActivatedRoute,
		private notificationService: NotificationMessageService,
	) {}

	ngOnInit() {
		this.siteId = Number(this.route.parent.snapshot.params.siteId);
		this.subSite = this.siteService.siteUtilizationSettingsData.subscribe((data:any) => {
			if (data.energy_utilization_settings && Object.keys(data.energy_utilization_settings).length) {
				return this.energySettings = data.energy_utilization_settings;
			}
		});
	}

	saveSiteEnergyUtilizationSettings() {
		let invalidInputs = this.elementRef.nativeElement.querySelectorAll('.invalid-input');
		invalidInputs.forEach((item) => {
			item.classList.remove('invalid-input');
		});

		this.siteService.saveSiteUtilizationSettings(this.siteId, this.settingType, this.energySettings).subscribe((res: any) => {
			if (res && res?.length) {
				return this.notificationService.setMessage('globalSuccessMsg');
			} else {
				return this.notificationService.setMessage('globalErrMsg');
			}
		});
	}

	validateInputs() {
		this.disableButton = false;

		for (const field in this.energySettings) {
			const newValue = this.energySettings[field];
			const ele = this.elementRef.nativeElement.querySelectorAll(`[name=${field}]`);
			this.render.removeClass(ele[0], 'invalid-input');

			if (newValue == null || newValue == undefined || isNaN(newValue)) {
				this.handleInvalidInputs(field);
				continue;
			}

			switch(field) {
				case 'max_disconnect_days':
				case 'minimum_meter_daily_kwh_usage':
				case 'maximum_meter_daily_kw_demand':
				case 'energy_cost':
				case 'energy_demand_charge':
					if (newValue < 0)
						this.handleInvalidInputs(field);
				break;
				case 'low_disconnect_range_min':
					if (newValue < 1)
						this.handleInvalidInputs(field);
				break;
				case 'low_disconnect_range_max':
					if (newValue < (this.energySettings.low_disconnect_range_min + 1))
						this.handleInvalidInputs(field);
				break;
				case 'mid_disconnect_range_min':
					if (newValue < (this.energySettings.low_disconnect_range_max + 1))
						this.handleInvalidInputs(field);
				break;
				case 'mid_disconnect_range_max':
					if (newValue < (this.energySettings.mid_disconnect_range_min + 1))
						this.handleInvalidInputs(field);
				break;
				case 'high_disconnect_limit':
					if (newValue < (this.energySettings.mid_disconnect_range_max + 1))
						this.handleInvalidInputs(field);
				break;
				default:
					this.disableButton = true;
				break;
			}
		}
	}

	handleInvalidInputs(field: string): boolean {
		const form = this.elementRef.nativeElement;
		const ele = form.querySelectorAll(`[name=${field}]`);
		if(ele && ele[0])
			this.render.addClass(ele[0], 'invalid-input');
		return this.disableButton = true;
	}

	ngOnDestroy() {
		this.subSite.unsubscribe();
	}
}
